(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/table/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/ui/table/assets/javascripts/prescript.js');

svs.ui = svs.ui || {};
svs.ui.reactTable = svs.ui.reactTable || {};
svs.ui.ReactTable = svs.ui.reactTable;


 })(window);